import ProductCard from '../../components/ProductCard';
import ProductQuickView from '../../components/ProductQuickView';
import { media } from '../../scripts/helpers';

/**
 * Блок заказа
 */
export default () => {
    ProductCard.create();
    ProductQuickView.create();

    const $infoBlock = $('.js-product-info-wrapper');
    const $orderBlock = $('.js-product-order-block');
    const $buttonsBlock = $('.js-product-page-buttons');
    const $submitMobileBlock = $('.js-product-page-submit-block');
    const tabletMedia = media('tablet');

    const showOrder = () => {
        $submitMobileBlock.addClass('is-block-visible');
        $orderBlock.addClass('is-block-visible');
        $infoBlock.addClass('is-block-hidden');
        $buttonsBlock.addClass('is-block-hidden');
    };

    const hideOrder = () => {
        $submitMobileBlock.removeClass('is-block-visible');
        $orderBlock.removeClass('is-block-visible');
        $infoBlock.removeClass('is-block-hidden');
        $buttonsBlock.removeClass('is-block-hidden');
    };

    /**
     * Открытие блока заказа
     */
    $(document).on('click', '.js-product-add-to-cart', () => {
        if (!tabletMedia.matches) {
            $infoBlock.fadeOut(200, () => {
                $orderBlock.fadeIn();
                showOrder();
            });
        } else {
            $buttonsBlock.fadeOut(200, () => {
                $submitMobileBlock.fadeIn();
                showOrder();
            });
        }
    });

    /**
     * Закрытие блока заказа и возврат информации о товаре
     */
    $(document).on('click', '.js-product-order-cancel', () => {
        if (!tabletMedia.matches) {
            $orderBlock.fadeOut(200, () => {
                $infoBlock.fadeIn();
                hideOrder();
            });
        } else {
            $submitMobileBlock.fadeOut(200, () => {
                $buttonsBlock.fadeIn();
                hideOrder();
            });
        }
    });

    /**
     * Очистка стилей на смартфонах
     */
    tabletMedia.addListener(mq => {
        if (mq.matches) {
            $orderBlock.css('display', '');
            $infoBlock.css('display', '');
        } else {
            $buttonsBlock.css('display', '');
            $submitMobileBlock.css('display', '');
        }
    });
};
